module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Hazel.6c46849e.jpg";